<div class="redirect-container">
  <div class="loader-wrapper">
    <app-loader style="margin-top: 100vh;"></app-loader>
  </div>
</div>
